module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3h6O3M1t3X3+XRoq26s9iSZsypwKpqmk9ckTvgrrjbQ1fdLkRtnFHeRVmcdtC3zbWZdM7Iv+OhTLYlAAAAB3RSTlMAYL8AIM/vi50ITwAAAPtJREFUeF7t2LmuxCAMhtGQScaQdV/e/0lHOFxMcxUpP02Wr0CiOUJIbpzsqVSfLFUfLrFHlmugPPuDsq+G+mYOyjVYvkNKwymGUhxKGbKAodMZK3mIgC4Aae7UTaAXKteKW0sMKitfCUGrQCsEVUGXgo4LIeLuD+Gf/VCoblquqTGobn01BDUCNRDUBt0D8oUQMGt3gvDPfqGiH7i+wKBi8BUQ1AvUQ9AQdCnoeERCCJi1C0P4Zz8OeqF3+kdxRqJJnIloFmc+hBaBFqJOoI5oE2j7BzKB5N40Ltbt3Jumzt4296Y5cAxDUZcsCodUrEVUtNVY3GUdh68Pf8CRt71hLab3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4ca.png
// module id = 1025
// module chunks = 0